import { Controller, useForm } from "react-hook-form";
import Input from "../../components/form-controls/Input";
import ReactSelect from 'react-select';
import InvalidFeedback from "../../components/InvalidFeedback";
import Tags from "../../components/Tags";
import Button from "../../components/form-controls/Button";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";


function FormHTTPNodePage({ node, onDelete, chatbotInfo }) {

    const { t  } = useTranslation();

    const defaultValues = {
        _id: '',
        is_root: false,
        name: '',
        parent_nodes: [],
        keywords: [],
        type: 'HTTP',
        http: {
            url_dev: '',
            url_prod: '',
            payload: [],
            responses: [],
        }
    }
    
    const PAYLOAD_VARIABLES = [
        { value: 'message', label: 'message' },
        { value: 'phone_number', label: 'phone_number' },
        { value: 'name', label: 'name' },
        { value: 'ticket_id', label: 'ticket_id' },
        { value: 'bot_id', label: 'bot_id' },
    ];
    
    const { control, register, watch, getValues, setValue, reset, handleSubmit, formState: { errors, isValid, isSubmitting } } = useForm({
        mode: 'onChange',
        defaultValues
    });

    const submit = async (data: any) => {
        data.position = node.position;

        await node.data.handleSaveNode({ nodeID: node.id, data, chatbotInfo })
    }

    useEffect(() => {
        reset(Object.assign(defaultValues, node.data ))
    }, [node.data])

    return (
        <>
            <div className="card-header">
                <h3 className="card-header-title">{t("platform.chatbot.http-node.config-title")}</h3>
                <p className="m-0"><small className="text-muted">{t("platform.chatbot.http-node.validation-http")}</small></p>
                { getValues('_id') && <p className="m-0"><small className="text-muted">Nodo id: {getValues('_id')}</small></p> }
            </div>
            <div className="card-body">
                <div className="mb-3">
                    <Input label={t("platform.chatbot.http-node.name")} errors={errors.name} {...register('name', { required: true })} />
                </div>

                <div className="mb-3">
                    <Input label={t("platform.chatbot.http-node.url-development")} errors={errors.http?.url_dev} {...register('http.url_dev', { required: true })} />
                </div>
                <div className="mb-3">
                    <Input label={t("platform.chatbot.http-node.url-production")} errors={errors.http?.url_prod} {...register('http.url_prod', { required: true })} />
                </div>

                {/* <div className="mb-3">
                    <label className="form-label" >{t("platform.chatbot.http-node.payload")}</label>
                    <Controller
                        control={control}
                        name='http.payload'
                        rules={{ required: true, min: 1 }}
                        render={({
                            field: { onChange, onBlur, value },
                            fieldState: { error },
                        }) => {
                            return (
                                <ReactSelect
                                    placeholder={'Seleccionas variables'}
                                    isMulti
                                    options={PAYLOAD_VARIABLES}
                                    classNamePrefix="react-select"
                                    isClearable={false}
                                    className={'react-select-creatable ' + (error ? 'is-invalid' : '')}
                                    onChange={(value: any) => onChange(value.map((v: any) => v.value))}
                                    value={ value.map( v => ({label: v, value: v})) }
                                />
                            )
                        }}
                    />
                    <InvalidFeedback error={errors.http?.payload} />
                </div> */}

                <div className="mb-3">
                    <label className="form-label" >{t("platform.chatbot.http-node.answers")}</label>
                    <Controller
                        control={control}
                        name='http.responses'
                        render={({
                            field: { onChange, value  },
                            fieldState: { error },
                        }) => {
                            return (
                                <Tags
                                    isInvalid={!!error}
                                    onChange={(values: any) => onChange(values)}
                                    initialValue={value.map( v => ({label: v, value: v}))}
                                />                            
                            )
                        }}
                    />
                    <InvalidFeedback error={errors.http?.responses} />
                </div>



                <div className="d-grid gap-2 my-3 ">
                    <Button type="submit" className="btn btn-primary" disabled={!isValid} isLoading={isSubmitting} onClick={handleSubmit(submit)}>{t("btn-save")}</Button>
                </div>

                {
                    getValues('_id') && (
                        <div className="d-grid gap-2 my-3 ">
                            <Button type="submit" className="btn btn-ghost-danger"  onClick={() => onDelete(getValues('_id')) }>{t("platform.chatbot.delete-node")}</Button>
                        </div>
                    )
                }


            </div>
        </>
    )
}
export default FormHTTPNodePage